import { hasMultipleAssignedUsers } from './assignedUsers';
import type { LeadAssignment } from './leadAssignment';

// non-IK lead with an added advisor
export const isSharedLead = (lead: Pick<LeadAssignment, 'type' | 'userIds'>) =>
    !hasMultipleAssignedUsers(lead.type) && lead.userIds.length > 1;
